export const DIM_UNITS = ['mm', 'm', 'in'];

const M_TO_UNIT = {
  mm: 1000,
  m: 1,
  in: 39.37007874,
};

/**
 * Đổi mét sang số theo đơn vị hiển thị (chưa làm tròn).
 */
export const metersToUnit = (meters, unit = 'mm') =>
  meters * (M_TO_UNIT[unit] ?? M_TO_UNIT.mm);

/**
 * Định dạng chiều dài (mét) thành chuỗi hiển thị cho nhãn DIM.
 * Chỉ đổi cách hiển thị, không ảnh hưởng kích thước thật.
 *
 * @param {number} meters
 * @param {{unit?: 'mm'|'m'|'in', decimals?: number, suffix?: boolean}} opts
 */
export const formatLength = (meters, opts = {}) => {
  const { unit = 'mm', decimals = 0, suffix = false } = opts;
  if (!Number.isFinite(meters)) return '';
  const value = metersToUnit(meters, unit);
  const d = Math.max(0, Math.min(6, decimals));
  const text = value.toFixed(d);
  // -0 => 0
  const normalized = Number(text) === 0 ? (0).toFixed(d) : text;
  return suffix ? `${normalized} ${unit}` : normalized;
};
